module.exports = __webpack_public_path__ + "static/case-carrera-e326a04e87113fe63fb5593a5f4e1901.mp4";